import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import ko from "./locales/ko/translation.json";
import en from "./locales/en/translation.json";
import zh from "./locales/zh/translation.json";
import ja from "./locales/ja/translation.json";
import es from "./locales/es/translation.json";

i18n.use(initReactI18next).init({
  resources: {
    ko: { translation: ko },
    en: { translation: en },
    zh: { translation: zh },
    ja: { translation: ja },
    es: { translation: es },
  },
  lng: "ko",
  fallbackLng: "ko",
  interpolation: { escapeValue: false },
});

/* ===== <html lang> 동기화 (언어별 폰트 적용용) ===== */
function syncHtmlLang(lng) {
  if (typeof document !== "undefined" && lng) {
    document.documentElement.lang = lng;
  }
}
syncHtmlLang(i18n.language);
i18n.on("languageChanged", syncHtmlLang);

export default i18n;
